interface TrackingProducts {
  goboat: {
    [key: string]: {
      id: string;
      name: string;
    };
  };
  giftcard: {
    [key: string]: {
      id: string;
      name: string;
    };
  };
  sauna: {
    [key: string]: {
      id: string;
      name: string;
    };
  };
  warranty: {
    id: string;
    name: string;
  };
}

const trackingProducts: TrackingProducts = {
  goboat: {
    1: {
      id: '5852d4ef20ff17366fcb6cf51',
      name: '1hourBooking',
    },
    1.5: {
      id: '5852d4ef20ff17366fcb6cf61',
      name: '1.5hourBooking',
    },
    2: {
      id: '5852d4ef20ff17366fcb6cf512',
      name: '2hourBooking',
    },
    2.5: {
      id: '5852d4ef20ff17366fcb6cf62',
      name: '2.5hourBooking',
    },
    3: {
      id: '5852d4ef20ff17366fcb6cf513',
      name: '3hourBooking',
    },
    3.5: {
      id: '5852d4ef20ff17366fcb6cf63',
      name: '3.5hourBooking',
    },
    4: {
      id: '5852d4ef20ff17366fcb6cf514',
      name: '4hourBooking',
    },
    4.5: {
      id: '5852d4ef20ff17366fcb6cf64',
      name: '4.5hourBooking',
    },
    5: {
      id: '5852d4ef20ff17366fcb6cf515',
      name: '5hourBooking',
    },
    5.5: {
      id: '5852d4ef20ff17366fcb6cf65',
      name: '5.5hourBooking',
    },
    6: {
      id: '5852d4ef20ff17366fcb6cf516',
      name: '6hourBooking',
    },
    6.5: {
      id: '5852d4ef20ff17366fcb6cf66',
      name: '6.5hourBooking',
    },
    7: {
      id: '5852d4ef20ff17366fcb6cf617',
      name: '7hourBooking',
    },
    7.5: {
      id: '5852d4ef20ff17366fcb6cf67',
      name: '7.5hourBooking',
    },
    8: {
      id: '5852d4ef20ff17366fcb6cf618',
      name: '8hourBooking',
    },
    8.5: {
      id: '5852d4ef20ff17366fcb6cf68',
      name: '8.5hourBooking',
    },
    9: {
      id: '5852d4ef20ff17366fcb6cf619',
      name: '9hourBooking',
    },
    9.5: {
      id: '5852d4ef20ff17366fcb6cf69',
      name: '9.5hourBooking',
    },
    10: {
      id: '5852d4ef20ff17366fcb6cf610',
      name: '10hourBooking',
    },
  },
  giftcard: {
    1: {
      id: '5852d4ef20ff17366fcb6cf517',
      name: '1hourGiftcard',
    },
    1.5: {
      id: '5852d4ef20ff17366fcb600001',
      name: '1.5hourGiftcard',
    },
    2: {
      id: '5852d4ef20ff17366fcb6cf518',
      name: '2hourGiftcard',
    },
    2.5: {
      id: '5852d4ef20ff17366fcb600002',
      name: '2.5hourGiftcard',
    },
    3: {
      id: '5852d4ef20ff17366fcb6cf519',
      name: '3hourGiftcard',
    },
  },
  sauna: {
    1: {
      id: '5852d4ef20ff17366fcb6cf520',
      name: '1hourSauna',
    },
    1.5: {
      id: '5852d4ef20ff17366fcb6c0001',
      name: '1.5hourSauna',
    },
    2: {
      id: '5852d4ef20ff17366fcb6cf521',
      name: '2hourSauna',
    },
    2.5: {
      id: '5852d4ef20ff17366fcb6c0002',
      name: '2.5hourSauna',
    },
    3: {
      id: '5852d4ef20ff17366fcb6cf522',
      name: '3hourSauna',
    },
    3.5: {
      id: '5852d4ef20ff17366fcb6c0003',
      name: '3.5hourSauna',
    },
    4: {
      id: '5852d4ef20ff17366fcb6cf523',
      name: '4hourSauna',
    },
    4.5: {
      id: '5852d4ef20ff17366fcb6c0004',
      name: '4.5hourSauna',
    },
    5: {
      id: '5852d4ef20ff17366fcb6cf524',
      name: '5hourSauna',
    },
    5.5: {
      id: '5852d4ef20ff17366fcb6c0005',
      name: '5.5hourSauna',
    },
    6: {
      id: '5852d4ef20ff17366fcb6cf525',
      name: '6hourSauna',
    },
  },
  warranty: {
    id: '5852d4ef20ff17366fcb6cf535',
    name: 'Cancellation warranty',
  },
};

export default trackingProducts;
